module.exports.default = module.exports = require('./lib/reading-time')
module.exports.readingTimeStream = require('./lib/stream')
